module.exports = __webpack_public_path__ + "img/ssm.83c6268e.png";